/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SyncBankConnections_connection_BankConnection_bankAccounts_BankAccount = { readonly __typename: 'BankAccount', readonly id: string | null, readonly bankAccountNumberLastFour: string | null, readonly bankRoutingNumber: string | null, readonly accountNumberLength: number, readonly institutionName: string | null, readonly accountHolderName: string | null, readonly ownerUuid: string };

export type SyncBankConnections_connection_BankConnection = { readonly __typename: 'BankConnection', readonly isVerifiable: boolean | null, readonly connectionId: string, readonly connectionType: _Types.BankConnectionType | null, readonly institutionMediumLogoUrl: string | null, readonly institutionName: string, readonly bankAccounts: ReadonlyArray<SyncBankConnections_connection_BankConnection_bankAccounts_BankAccount | null> | null };

export type SyncBankConnections_Mutation = { readonly __typename: 'Mutation', readonly connection: SyncBankConnections_connection_BankConnection | null };


export type SyncBankConnectionsVariables = _Types.Exact<{
  connectionGuid: _Types.Scalars['String']['input'];
  divvyUuid: _Types.Scalars['String']['input'];
  userGuid: _Types.Scalars['String']['input'];
}>;


export type SyncBankConnections = SyncBankConnections_Mutation;


export const SyncBankConnectionsDocument = gql`
    mutation SyncBankConnections($connectionGuid: String!, $divvyUuid: String!, $userGuid: String!) {
  connection: syncBankConnections(
    connectionGuid: $connectionGuid
    divvyUuid: $divvyUuid
    userGuid: $userGuid
  ) {
    isVerifiable
    bankAccounts {
      id
      bankAccountNumberLastFour
      bankRoutingNumber
      accountNumberLength
      institutionName
      accountHolderName
      ownerUuid
    }
    connectionId
    connectionType
    institutionMediumLogoUrl
    institutionName
  }
}
    `;
export type SyncBankConnectionsMutationFn = Apollo.MutationFunction<SyncBankConnections, SyncBankConnectionsVariables>;

/**
 * __useSyncBankConnections__
 *
 * To run a mutation, you first call `useSyncBankConnections` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBankConnections` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBankConnections, { data, loading, error }] = useSyncBankConnections({
 *   variables: {
 *      connectionGuid: // value for 'connectionGuid'
 *      divvyUuid: // value for 'divvyUuid'
 *      userGuid: // value for 'userGuid'
 *   },
 * });
 */
export function useSyncBankConnections(baseOptions?: Apollo.MutationHookOptions<SyncBankConnections, SyncBankConnectionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBankConnections, SyncBankConnectionsVariables>(SyncBankConnectionsDocument, options);
      }
export type SyncBankConnectionsHookResult = ReturnType<typeof useSyncBankConnections>;
export type SyncBankConnectionsMutationResult = Apollo.MutationResult<SyncBankConnections>;
export type SyncBankConnectionsMutationOptions = Apollo.BaseMutationOptions<SyncBankConnections, SyncBankConnectionsVariables>;